import gql from 'graphql-tag';

const typeDefs = gql`
  extend type Query {
    app: AppSetting!
  }

  type AppSetting {
    id: ID!
    drawerOpen: Boolean!
    currentEditProductId: Int!
    order: Int!
    passwordCheck: Boolean!
    browser: String
  }
`;

export default typeDefs;



// WEBPACK FOOTER //
// ./src/store/schema.ts